(function (Drupal, $) {
  Drupal.behaviors.VideoSection = {
    attach: function (context) {
      $(once("paragraph-embed-youtube-processed", ".paragraph-embed-youtube", context))
        .each(function () {
          const btnPlay = document.querySelector(
            ".paragraph-embed-youtube .btn-play-youtube-video"
          );
          const thumbnail = document.querySelector(
            ".paragraph-embed-youtube .thumbnail"
          );

          if (!thumbnail) return;

          btnPlay.addEventListener("click", () => {
            console.log("click");
            const iframe = btnPlay
              .closest(".embed-youtube__video")
              ?.querySelector(".video iframe");
            if (!iframe) return;

            thumbnail.classList.add("hidden");
          });
        }); // once
    },
  };
})(Drupal, jQuery);
